import { registerPlugin } from '@capacitor/core';
const UnityAds = registerPlugin('Unityads', {
    web: () => import('./web').then((m) => new m.UnityAdsWeb()),
});
export * from './definitions';
export { UnityAds };
//# sourceMappingURL=index.js.map